import Api from '../http.service';

/** get all credits transactions
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {String} payload.data
 * @param {string} payload.sort
 * @param {string} payload.order
 * 

 */
export const getByPaging = ({
  pageNumber = 0,
  itemPerPage = 10,
  data,
  sort,
  order,
}) =>
  Api.GET({
    url: `gateway_credits/all?page=${
      pageNumber - 1
    }&size=${itemPerPage}&where=${data.filter}&sort=${sort}&order=${order}`,
  });
